#@import GliveBooking.Models.Event
#@export GliveBooking.Collections.Events

class GliveBooking.Collections.Events extends BookingV2.Collections.Base
  model: GliveBooking.Models.Event

  times: ->
    @map((event) -> event.getTime())
